<div class="challenge-rules" *ngIf="rules">
  <div [innerHtml]="rules"></div>
</div>
